import { fromJS } from "immutable";

import {
    SET_SEARCH_TERM,
    SET_LOCATIONS,
    SET_LOCATION,
    SET_FILTER_ITEMS,
    SET_SEARCH_RESULT,
    SET_FILTERS,
    SET_MUNICIPALITIES,
    SET_LOCATIONS_NEAR,
    SET_USER_LOCATION,
    SET_SEARCH_ERROR,
} from "./../actions/index";

const initialState = fromJS({
    searchTerm: null,
    searchResult: { result: null },
    churches: null,
    locations: null,
    churchesNear: null,
    userLocation: null,
    location: null,
    filterItems: [],
    filters: null,
    municipalities: [],
    nextPage: -1,
    totalAvailable: 0,
    fetchAgain: false,
    latestFetchType: null,
    searchErrorMsg: "",
});

function searchReducer(state = initialState, action) {
    switch (action.type) {
    case SET_SEARCH_TERM:
        return state.set("searchTerm", action.data).set("fetchAgain", true);
    case SET_SEARCH_RESULT:
        if (action.reload) {
            return state
                .set("churches", action.data.result)
                .set("searchResult", action.data)
                .set("nextPage", action.nextPage)
                .set("totalAvailable", action.totalAvailable)
                .set("fetchAgain", false)
                .set("latestFetchType", "search")
                .set("searchErrorMsg", "");
        } else {
            const result = [
                ...state.get("churches"),
                ...action.data.result,
            ];
            return state
                .set("churches", result)
                .set("nextPage", action.nextPage)
                .set("totalAvailable", action.totalAvailable)
                .set("fetchAgain", false)
                .set("latestFetchType", "search")
                .set("searchErrorMsg", "");
        }
    case SET_LOCATIONS:
        return state.set("locations", action.data);
    case SET_USER_LOCATION:
        return state.set("userLocation", action.data);
    case SET_LOCATIONS_NEAR:
        return state
            .set("churchesNear", action.data)
            .set("nextPage", action.nextPage)
            .set("totalAvailable", action.totalAvailable)
            .set("latestFetchType", "location");
    case SET_LOCATION:
        return state.set("location", action.data);
    case SET_FILTER_ITEMS:
        return state
            .set("filterItems", action.data)
            .set("fetchAgain", true);
    case SET_FILTERS:
        return state.set("filters", action.data);
    case SET_MUNICIPALITIES:
        return state.set("municipalities", action.data);
    case SET_SEARCH_ERROR:
        return state.set("searchErrorMsg", action.data);
    default:
        return state;
    }
}

export default searchReducer;



// WEBPACK FOOTER //
// ./src/reducers/search.js